import React, { useEffect } from 'react';
import { Link, withRouter } from 'react-router-dom';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Button from 'react-bootstrap/Button';
import { FaAngleLeft } from 'react-icons/fa';
import { useI18n } from '../../i18n';
import './PageHeader.css';

const PageHeader = ({
    title,
    subtitle,
    breadcrumbs = [],
    backTo,
    backLabel,
    count,
    countLabel,
    countSingular,
    countLoading = false,
    statusBadge,
    actions,
    className = '',
    pageTitle,
    history,
}) => {
    const { t } = useI18n();
    const appName = t('common.appName');
    const resolvedBack = backLabel || t('common.back');
    const resolvedCount = countLabel || t('common.items');
    const resolvedSingular = countSingular || t('common.item');

    useEffect(() => {
        const label = pageTitle || (typeof title === 'string' ? title : '');
        document.title = label ? `${label} — ${appName}` : appName;
        return () => {
            document.title = appName;
        };
    }, [title, pageTitle, appName]);

    const showCount = count !== undefined && count !== null && !countLoading;
    const countText = showCount
        ? `${count} ${count === 1 ? resolvedSingular : resolvedCount}`
        : null;

    return (
        <div className={`header page-header ${className}`.trim()}>
            {breadcrumbs.length > 0 && (
                <div className="page-breadcrumb">
                    <Breadcrumb className="page-breadcrumb-list">
                        <Breadcrumb.Item linkAs={Link} linkProps={{ to: '/' }}>
                            {t('common.home')}
                        </Breadcrumb.Item>
                        {breadcrumbs.map((crumb, index) => {
                            const isLast = index === breadcrumbs.length - 1;
                            if (isLast || !crumb.path) {
                                return (
                                    <Breadcrumb.Item key={crumb.label + index} active>
                                        {crumb.label}
                                    </Breadcrumb.Item>
                                );
                            }
                            return (
                                <Breadcrumb.Item
                                    key={crumb.label + index}
                                    linkAs={Link}
                                    linkProps={{ to: crumb.path }}
                                >
                                    {crumb.label}
                                </Breadcrumb.Item>
                            );
                        })}
                    </Breadcrumb>
                </div>
            )}

            <div className="page-header-body">
                <div className="page-header-info">
                    {title && (
                        <div className="header-title-row">
                            {typeof title === 'string' ? (
                                <h1 className="header-title">{title}</h1>
                            ) : (
                                title
                            )}
                            {statusBadge}
                        </div>
                    )}
                    {subtitle && <div className="header-subtitle">{subtitle}</div>}
                </div>

                <div className="header-actions">
                    {backTo && (
                        <Button
                            variant="secondary"
                            size="sm"
                            className="page-header-back"
                            onClick={() => history.push(backTo)}
                        >
                            <FaAngleLeft /> {resolvedBack}
                        </Button>
                    )}
                    {countText && <span className="header-count">{countText}</span>}
                    {actions}
                </div>
            </div>
        </div>
    );
};

export default withRouter(PageHeader);
